import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RegisterName } from '@schir-int-client/register-shared';
import { Router } from '@angular/router';
import { Aktenzeichen, AktenzeichenRendererProvider } from '@schir-int-client/aktenzeichen-shared';

@Component({
	selector: 'schir-int-client-aktenzeichen',
	templateUrl: 'aktenzeichen.component.html',
	styleUrl: 'aktenzeichen.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AktenzeichenComponent {
	private readonly router = inject(Router);
	protected readonly renderer = inject(AktenzeichenRendererProvider).getRenderer();

	@Input({ required: true }) aktenzeichen: string | Aktenzeichen;
	@Input() verfahrenId: number;
	@Input() preOpenAction: () => void;

	hasRegisterBlatt() {
		if (typeof this.aktenzeichen === 'string') {
			return !this.aktenzeichen.includes(RegisterName.AR);
		}
		return this.aktenzeichen.register !== RegisterName.AR;
	}

	openRegisterblatt(e: Event) {
		e.stopPropagation();
		this.preOpenAction?.();
		this.router.navigate(['/verfahrenDetail', this.verfahrenId]).then();
	}
}
